function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23037",
    transform: "translate(-450.51 -191.727)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 679",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(450.51 191.727)",
    style: {
      fill: "#ffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16418",
    d: "M10.121 144.024.3 139.887a.214.214 0 0 0-.3.2v11.06a.683.683 0 0 0 .43.635l9.53 3.812a.214.214 0 0 0 .293-.2V144.22a.214.214 0 0 0-.132-.196z",
    transform: "translate(464.84 71.977)",
    style: {
      fill: "#98cbf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16419",
    d: "m38.478 12.566 9.5-4a.214.214 0 0 0 .007-.39l-9.3-4.339a.684.684 0 0 0-.578 0l-9.3 4.339a.214.214 0 0 0 .007.39l9.5 4a.213.213 0 0 0 .166 0z",
    transform: "translate(437.38 202.259)",
    style: {
      fill: "#98cbf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16420",
    d: "M272 144.22v11.171a.214.214 0 0 0 .293.2l9.53-3.812a.683.683 0 0 0 .43-.635v-11.06a.214.214 0 0 0-.3-.2l-9.825 4.137a.214.214 0 0 0-.128.199z",
    transform: "translate(204.459 71.977)",
    style: {
      fill: "#98cbf2"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.419d6155c9202ea99bfa36b6bf487a85.svg";
export { ForwardRef as ReactComponent };